import {
	TRIGGER_TXN_STATUS_API_CALL,
	TRIGGER_TXN_STATUS_API_CALL_SUCCESS,
	TRIGGER_CLEAR_TXN_DETAILS,
} from 'redux/actionTypes';

export function triggerTxnStatusApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_TXN_STATUS_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerTxnStatusApiCallSuccess(data) {
	return {
		type: TRIGGER_TXN_STATUS_API_CALL_SUCCESS,
		data,
	};
}

export function triggerClearTxnDetails(data) {
	return {
		type: TRIGGER_CLEAR_TXN_DETAILS,
		data,
	};
}
